export const flightArrangementType = {
  amadeus: "AMADEUS",
  travelfusion: "Travelfusion",
  infini_lcc: "INFINI LCC",
  gotogate: "Gotogate",
};
